import {Package, DollarSign, Users, TrendingUp} from 'lucide-react'
import { formatUSD } from '@/lib/freight'
import type { FreightLead } from '@/hooks/useFreightLeads'

interface AdminStatsProps {
  leads: FreightLead[]
  loading?: boolean
}

function AdminStats({ leads, loading }: AdminStatsProps) {
  const totalLeads = leads.length
  const totalPipeline = leads.reduce((sum, l) => sum + (Number(l.estimatedRate) || 0), 0)
  const avgRate = totalLeads > 0 ? totalPipeline / totalLeads : 0

  const now = Date.now()
  const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000
  const newThisWeek = leads.filter((l) => new Date(l.createdAt).getTime() >= sevenDaysAgo).length

  const cards = [
    { label: 'Total Leads', value: totalLeads.toLocaleString(), icon: Users, accent: 'text-[#10B981] bg-emerald-50' },
    { label: 'Estimated Pipeline', value: formatUSD(totalPipeline), icon: DollarSign, accent: 'text-[#10B981] bg-emerald-50' },
    { label: 'Avg. Quote Value', value: formatUSD(avgRate), icon: Package, accent: 'text-[#1E293B] bg-slate-100' },
    { label: 'New This Week', value: newThisWeek.toLocaleString(), icon: TrendingUp, accent: 'text-[#1E293B] bg-slate-100' },
  ]

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((c) => (
        <div key={c.label} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{c.label}</span>
            <span className={`inline-flex items-center justify-center w-9 h-9 rounded-lg ${c.accent}`}>
              <c.icon className="w-4.5 h-4.5" />
            </span>
          </div>
          {loading ? (
            <div className="mt-3 h-7 w-20 rounded bg-slate-100 animate-pulse" />
          ) : (
            <p className="mt-3 text-2xl font-bold text-[#0F172A]">{c.value}</p>
          )}
        </div>
      ))}
    </div>
  )
}

export default AdminStats
